/*
 * =========================================
 * OFFER SETTINGS
 * =========================================
 *
 * Set the exact date/time when the offer
 * expires.
 *
 * September 5, 2026
 * 11:59:59 PM
 */

const HDR_CD_DISCOUNT_END_DATE = new Date(
  2026, // Year
  8, // September
  5, // Day
  23, // Hour
  59, // Minutes
  59, // Seconds
);

/*
 * =========================================
 * ELEMENTS
 * =========================================
 */

const hdrCdDiscountOverlay = document.getElementById("hdr_cd_discount_overlay");

const hdrCdDiscountCloseButton = document.getElementById(
  "hdr_cd_discount_close",
);

const hdrCdDiscountClaimButton = document.getElementById(
  "hdr_cd_discount_claim",
);

const hdrCdDiscountTimer = document.getElementById("hdr_cd_discount_timer");

/*
 * =========================================
 * CHECK OFFER
 * =========================================
 */

function hdrCdDiscountIsOfferActive() {
  const now = new Date();

  return now.getTime() < HDR_CD_DISCOUNT_END_DATE.getTime();
}

/*
 * =========================================
 * SHOW MODAL
 * =========================================
 */

function hdrCdDiscountShowModal() {
  /*
   * If the offer has expired,
   * don't show the modal.
   */

  if (!hdrCdDiscountIsOfferActive()) {
    hdrCdDiscountHideModal();

    return;
  }

  hdrCdDiscountOverlay.style.display = "flex";
}

/*
 * =========================================
 * HIDE MODAL
 * =========================================
 */

function hdrCdDiscountHideModal() {
  hdrCdDiscountOverlay.style.display = "none";
}

/*
 * =========================================
 * COUNTDOWN
 * =========================================
 */

function hdrCdDiscountUpdateCountdown() {
  const now = new Date();

  const difference = HDR_CD_DISCOUNT_END_DATE.getTime() - now.getTime();

  /*
   * OFFER EXPIRED
   */

  if (difference <= 0) {
    hdrCdDiscountHideModal();

    return;
  }

  /*
   * Calculate days
   */

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));

  /*
   * Calculate hours
   */

  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);

  /*
   * Calculate minutes
   */

  const minutes = Math.floor((difference / (1000 * 60)) % 60);

  /*
   * Calculate seconds
   */

  const seconds = Math.floor((difference / 1000) % 60);

  /*
   * Display countdown
   */

  if (days > 0) {
    hdrCdDiscountTimer.textContent =
      days +
      "d " +
      String(hours).padStart(2, "0") +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(seconds).padStart(2, "0");
  } else {
    hdrCdDiscountTimer.textContent =
      String(hours).padStart(2, "0") +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(seconds).padStart(2, "0");
  }
}

/*
 * =========================================
 * CLOSE BUTTON
 * =========================================
 */

hdrCdDiscountCloseButton.addEventListener("click", function () {
  hdrCdDiscountHideModal();
});

/*
 * =========================================
 * CLICK OUTSIDE
 * =========================================
 */

hdrCdDiscountOverlay.addEventListener("click", function (event) {
  if (event.target === hdrCdDiscountOverlay) {
    hdrCdDiscountHideModal();
  }
});

/*
 * =========================================
 * ESC KEY
 * =========================================
 */

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    hdrCdDiscountHideModal();
  }
});

/*
 * =========================================
 * CTA
 * =========================================
 *
 * Change the URL below to your Shopify
 * collection or product page.
 */

hdrCdDiscountClaimButton.addEventListener("click", function () {
  /*
   * Check that the offer is still active.
   */

  if (!hdrCdDiscountIsOfferActive()) {
    hdrCdDiscountHideModal();

    return;
  }

  /*
   * Example:
   *
   * window.location.href =
   * "/collections/sale";
   *
   *
   * Currently just closes the modal.
   */

  window.location.href =
   "/collections/offers-page";

  hdrCdDiscountHideModal();
});

/*
 * =========================================
 * INITIAL LOAD
 * =========================================
 */

hdrCdDiscountShowModal();

hdrCdDiscountUpdateCountdown();

/*
 * =========================================
 * LIVE COUNTDOWN
 * =========================================
 */

const hdrCdDiscountCountdownInterval = setInterval(function () {
  /*
   * Stop timer when offer expires.
   */

  if (!hdrCdDiscountIsOfferActive()) {
    hdrCdDiscountHideModal();

    clearInterval(hdrCdDiscountCountdownInterval);

    return;
  }

  hdrCdDiscountUpdateCountdown();
}, 1000);
